import React, { Component, createRef } from "react";
import {
  POST,
  loading,
  tokens,
  alert,
  float,
} from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import LOGO from "../assets/images/logo-w.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullname: "",
      phone: "",
      email: "",
      password: "",
      password_view: "password",
    };
  }
  componentDidMount() {
    loading(false);
  }
  Register = async () => {
    const { fullname, phone, email, password } = this.state;
    if (!fullname) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อ-นามสกุล");
      return;
    }
    if (!phone) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทร");
      return;
    }
    if (!email) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกอีเมล");
      return;
    }
    if (!email.includes("@")) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกรูปแบบอีเมลให้ถูกต้อง");
      return;
    }
    if (!password) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกรหัสผ่าน");
      return;
    }
    await fetch(
      `${"https://swiftgamepay-default-rtdb.asia-southeast1.firebasedatabase.app/"}user/${email.split("@")[0]}.json`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fullname: fullname,
          phone: phone,
          email: email,
          password: btoa(password),
        }),
      }
    );
    alert(
      "login",
      "success",
      "สำเร็จ",
      `การสมัครสมาชิกของท่านเสร็จสมบูรณ์แล้ว`
    );
  };

  render() {
    const { fullname, phone, email, password, password_view } = this.state;
    return (
      <div className="w-100 min-vh-100 background position-relative">
        <Navbar />
        <div className="row w-100 mx-0">
          <div className="col-12 d-flex align-items-center justify-content-center d-md-none bg-info py-3">
            <img
              alt="logo"
              src={LOGO}
              className="w-75"
              style={{ minWidth: 350 }}
            />
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
            <div className="col-11 col-md-10 col-lg-7 col-xl-6 mx-auto my-5">
              <h2 className="fw-bold text-dark mb-3">สมัครสมาชิก</h2>
              <label className="mb-1">ชื่อ-นามสกุล</label>
              <input
                className="form-control mb-3"
                type="text"
                placeholder="ชื่อ-นามสกุล"
                onChange={(e) => {
                  this.setState({ fullname: e.target.value });
                }}
                value={fullname}
              />
              <label className="mb-1">เบอร์โทร</label>
              <input
                className="form-control mb-3"
                type="text"
                placeholder="เบอร์โทร"
                maxLength={10}
                onChange={(e) => {
                  if (!float(e.target.value)) {
                    return;
                  }
                  this.setState({ phone: e.target.value });
                }}
                value={phone}
              />
              <label className="mb-1">อีเมล</label>
              <input
                className="form-control mb-3"
                type="text"
                placeholder="อีเมล"
                onChange={(e) => {
                  this.setState({ email: e.target.value });
                }}
                value={email}
              />
              <label className="mb-1">รหัสผ่าน</label>
              <div className="position-relative">
                <input
                  className="form-control mb-3"
                  type={password_view}
                  placeholder="รหัสผ่าน"
                  onChange={(e) => {
                    this.setState({ password: e.target.value });
                  }}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      this.Register();
                    }
                  }}
                  value={password}
                />
                <div
                  className="wpx-40 hpx-40 d-flex justify-content-center align-items-center icon pointer position-absolute"
                  style={{ right: 0, top: 1 }}
                  onClick={() => {
                    this.setState({
                      password_view:
                        password_view === "password" ? "text" : "password",
                    });
                  }}
                >
                  {password_view === "password" ? "\uf06e" : "\uf070"}
                </div>
              </div>
              <button
                type="button"
                className="btn btn-dark w-100 mb-3"
                onClick={() => {
                  this.Register();
                }}
              >
                สมัครสมาชิก
              </button>
              <div className="w-100 text-center">
                <a
                  className="text-decoration-none text-dark mt-3"
                  href="/login"
                >
                  เข้าสู่ระบบ
                </a>
              </div>
            </div>
          </div>
          <div className="col-6 d-none d-md-flex align-items-center justify-content-center bg-info min-vh-100">
            <img
              alt="logo"
              src={LOGO}
              style={{ width: "60%", minWidth: 400 }}
            />
          </div>
        </div>
      </div>
    );
  }
}
